import { Amplify } from 'aws-amplify'
import { Environment } from '../../environments/environment.interface'

export const configureAmplify = (awsCognito: Environment): void => {
    const uiUrl = `${location.origin}${location.pathname}`.replace(/\/$/, '')

    Amplify.configure({
        Auth: {
            Cognito: {
                userPoolId: awsCognito.awsCognito.userPoolId,
                userPoolClientId: awsCognito.awsCognito.userPoolWebClientId,
                loginWith: {
                    oauth: {
                        domain: awsCognito.awsCognito.domain,
                        scopes: ['phone', 'email', 'profile', 'aws.cognito.signin.user.admin', 'openid'],
                        redirectSignIn: [uiUrl],
                        redirectSignOut: [uiUrl],
                        responseType: 'code'
                    }
                }
            }
        }
    })
}
